import { createFileRoute } from '@tanstack/react-router';
import type { ReactElement } from 'react';
import { z } from 'zod';

import { LinkViews } from '~/features/links/os/link-views';

/** The step past the rule (when it fires, or what carries over), and `by=hand` for the link set up by hand. */
const search = z.object({ step: z.enum(['condition', 'fields']).optional(), by: z.enum(['hand']).optional() });

/** A new link: OS first (board access-link-os), or set up by hand on the same rule (board access-link-new). */
function NewLinkRoute(): ReactElement {
  const { recordId } = Route.useParams();
  const { step, by } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <LinkViews
      key={recordId}
      recordId={recordId}
      linkId={null}
      by={by ?? null}
      step={step ?? 'rule'}
      onStep={(next) => void navigate({ search: (prev) => ({ ...(prev.by === undefined ? {} : { by: prev.by }), ...(next === 'rule' ? {} : { step: next }) }) })}
      onBy={(next) => void navigate({ search: next === null ? {} : { by: next } })}
    />
  );
}

export const Route = createFileRoute('/_app/records/$recordId/links/new')({
  validateSearch: search,
  component: NewLinkRoute,
});
